import React, { useCallback } from "react";
import PropTypes from "prop-types";
// import { Button, SecondaryButton } from "../inputs/Button";
import styled from "styled-components";
import {
  DialogSurface,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  makeStyles
} from "@fluentui/react-components";

const headerStyle = {
  fontFamily: "var(--fontFamilyBase)",
  fontSize: "var(--fontSizeBase500)",
  fontWeight: 600,
  lineHeight: "var(--lineHeightBase500)"
  // color: "#BDBDBD"
};

const buttonStyle = {
  //styleName: Body 1 Strong;
  fontFamily: "var(--fontFamilyBase)",
  fontSize: "var(--fontSizeBase300)",
  fontWeight: 600,
  lineHeight: "var(--lineHeightBase300)"
};

const cancelStyle = {
  ...buttonStyle
  // background: "#FFFFFF33"
};

export default function DialogPublish({
  tag,
  title,
  onCancel,
  cancelLabel,
  onConfirm,
  confirmLabel,
  bottomNav,
  children,
  maxWidth,
  disabled,
  ...rest
}) {
  const onSubmitForm = useCallback(
    e => {
      e.preventDefault();

      if (onConfirm) {
        onConfirm(e);
      }
    },
    [onConfirm]
  );

  const dialogStyle = {
    background: "var(--colorNeutralBackground1)",
    gap: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    maxWidth: "500px" // Add maxWidth to the style object only if it exists
  };

  const dialogContentStyle = {
    paddingTop: "20px"
  };

  return (
    <DialogSurface style={dialogStyle} as={tag} onSubmit={onSubmitForm} {...rest}>
      <DialogTitle style={headerStyle}>{title}</DialogTitle> <DialogContent> {children} </DialogContent>{" "}
      {(onConfirm || onCancel || bottomNav) && (
        <DialogActions style={{ justifyContent: "flex-end", marginTop: "10px", width: "100%" }}>
          {" "}
          {bottomNav}{" "}
          {onCancel && (
            <Button style={cancelStyle} appearance="secondary" onClick={onCancel}>
              {" "}
              {cancelLabel}{" "}
            </Button>
          )}{" "}
          {onConfirm && (
            <Button
              style={buttonStyle}
              disabled={disabled}
              appearance="primary"
              type="submit"
              onClick={tag === "form" ? null : onConfirm}
            >
              {" "}
              {confirmLabel}{" "}
            </Button>
          )}{" "}
        </DialogActions>
      )}{" "}
    </DialogSurface>
  );
}

DialogPublish.propTypes = {
  tag: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  cancelLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func,
  confirmLabel: PropTypes.string.isRequired,
  bottomNav: PropTypes.node,
  children: PropTypes.node
};

DialogPublish.defaultProps = {
  tag: "form",
  confirmLabel: "Ok",
  cancelLabel: "Cancel"
};
